module.exports = __webpack_public_path__ + "static/media/circle-x.0b91aba8.svg";